import React, { useState } from "react";
import { ReactComponent as RaceSportIcon } from '../../assets/race-flag.svg';

import { getLabel } from "../../data/labels";
import { getUrlToFetch } from '../../data/utils/getUrlToFetch';
import { getAccountIds } from '../../data/utils/getAccountIds';
import { getConfiguration } from '../../data/utils/configuration';
import { useFetch } from "../../data/fetch/useFetch";
import { systemCode, urls, xs_languageCode, xs_sessionToken } from "../..";
import XRouterLink from "../seo/xrouter/XRouterLink";
import { isLoadedInIframe } from "../../data/utils/isLoadedInIframe";

export function resolveRaceSportPageUrlCustom(template) {
    if (!template) return template;
    return template
        .replace(/{{SYSTEM_CODE}}/g, systemCode)
        .replace(/{{TOKEN}}/g, xs_sessionToken)
        .replace(/{{LANGUAGE}}/g, (xs_languageCode || 'it').toLowerCase());
}

export function LinkToRaceSportPage(props) {
    const className = props.className;
    const hrefLinkXSport = props.hrefLinkXSport;
    const hrefLinkXCasino = props.hrefLinkXCasino;

    return (
        hrefLinkXCasino?
            <a href={hrefLinkXCasino}  target={isLoadedInIframe()? '_top':'_self'} className={className}>
                {props.children}
            </a>
         
        :
            <XRouterLink to={hrefLinkXSport}  className={className}>
                {props.children}
            </XRouterLink>

    )
}

export default function RaceSportButtonScroller({ className = '' }) {
    const conf = getConfiguration();
    const xrc = conf.xrc ?? { enabled: true, url: "/XRaces/infoSport" };
    const [isRaceActive, setIsRaceActive] = useState(false);
    const numConto = getAccountIds()?.split(";")?.[1] || '';
    let hrefLinkXSport =  `${urls.base}/${urls?.['race-sport']?.['race-sport']}` || '/race-sport'; //pathname configurato lato sportbook
    const hrefLinkXCasino = typeof window.cg_SEO_URL_MAPPING_REVERSE != 'undefined' ?  JSON.parse(window.cg_SEO_URL_MAPPING_REVERSE)?.['xcasinoracesport']: null; //pathname configurato lato contogioco
    
    if (xrc?.customUrl) {
        hrefLinkXSport = resolveRaceSportPageUrlCustom(xrc.customUrl);
    }

    const [isLoading, isError, data] = useFetch(getUrlToFetch(xrc?.url), {
        system_code: systemCode,
        num_conto: numConto,
        skipBaseParams: true
    }, (data) => {
        try {
            if (parseInt(data?.raceAttiva) > 0 && !isRaceActive) {
                setIsRaceActive(true);
            }
        } catch (err) {
            if (isRaceActive) {
                setIsRaceActive(false);
            }
            console.error(err);
        }
    },
        xrc?.enabled ? true : false
    );


    return (isRaceActive && xs_sessionToken &&
        <>
            <LinkToRaceSportPage hrefLinkXCasino={hrefLinkXCasino} hrefLinkXSport={hrefLinkXSport} className={`c_7_1_1 xsport-race-sport-icon-container relative h-sports-navbar-height min-w-sports-navbar-height mx-1 shrink-0 flex flex-col items-center justify-center ${className}`.trim()}>
                <div className="c_7_1_1_0 min-w-[60px] grid grid-cols-12 grid-rows-12 max-h-full leading-none items-center justify-items-center  ">
                    <div className="c_7_1_1_1 xsport-race-sport-icon xs-sport-icon col-start-1 col-end-13 row-start-1 row-end-10 inline-block h-[24px] w-[24px]">
                        <RaceSportIcon />
                    </div>
                    <div className="c_7_1_1_2 col-start-1 col-end-13 row-start-10 row-end-13 font-bold text-xxs text-cs1 uppercase truncate">{getLabel('race_sport.title', 'Race Sport')}</div>
                </div>
            </LinkToRaceSportPage>
        </>
    )
}